function buildData(form: any): FormData {
  const formData = new FormData();
  if (form?.file) {
    form.file.forEach((file: File) => {
      formData.append("files", file, file.name);
    });
  }
  if (form?.textAnswer) {
    formData.append(
      "textAnswer",
      new Blob([...JSON.stringify(form?.textAnswer)], {
        type: "application/json",
      })
    );
  }
  return formData;
}

export { buildData };
